import { render, staticRenderFns } from "./ButtonMessageEditor.vue?vue&type=template&id=0c888a8c&scoped=true"
import script from "./ButtonMessageEditor.vue?vue&type=script&lang=js"
export * from "./ButtonMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./ButtonMessageEditor.vue?vue&type=style&index=0&id=0c888a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c888a8c",
  null
  
)

export default component.exports